import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Target, Users, Award, CheckCircle2, ArrowRight, Timer, TrendingUp, Heart, Zap, Star, Calendar } from 'lucide-react';
export function PacerProgram() {
  return <div className="w-full bg-gray-50" data-id="element-1383">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0E578E] to-[#01AAE7] py-16 sm:py-20 overflow-hidden" data-id="element-1384">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 opacity-10" data-id="element-1385">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" data-id="element-1386"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-1387"></div>
        </div>

        {/* Diagonal Lines Pattern */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
      }} data-id="element-1388"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-1389">
          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight" data-id="element-1390">
            RaceLookup
            <span className="block mt-2 bg-gradient-to-r from-white via-cyan-100 to-white bg-clip-text text-transparent" data-id="element-1391">
              Pacer Program
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-1392">
            Help runners achieve their goals by becoming a certified RaceLookup
            Pacer. Lead groups to their target finish times while building
            community and inspiring others.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto" data-id="element-1393">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1394">
              <div className="text-3xl font-black text-white mb-1" data-id="element-1395">2,500+</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-1396">
                Active Pacers
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1397">
              <div className="text-3xl font-black text-white mb-1" data-id="element-1398">50K+</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-1399">
                Runners Paced
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1400">
              <div className="text-3xl font-black text-white mb-1" data-id="element-1401">1,200+</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-1402">
                Events Covered
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What is a Pacer Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-1403">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1404">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1405">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1406">
              What is a Pacer?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1407">
              Pacers are experienced runners who lead groups at specific target
              finish times during races. They maintain consistent pace, provide
              encouragement, and help runners achieve their time goals through
              strategic pacing and motivation.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1408">
            <div className="text-center" data-id="element-1409">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-1410">
                <Clock className="h-8 w-8 text-white" data-id="element-1411" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1412">
                Consistent Pacing
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1413">
                Maintain steady splits throughout the race to help runners avoid
                starting too fast or slowing down
              </p>
            </div>

            <div className="text-center" data-id="element-1414">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-1415">
                <Heart className="h-8 w-8 text-white" data-id="element-1416" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1417">
                Motivation & Support
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1418">
                Provide encouragement and positive energy to keep runners
                motivated through challenging moments
              </p>
            </div>

            <div className="text-center" data-id="element-1419">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-1420">
                <Target className="h-8 w-8 text-white" data-id="element-1421" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1422">
                Goal Achievement
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1423">
                Guide runners to cross the finish line at their target time,
                helping them achieve personal records
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-1424">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1425">
          <div className="text-center mb-12" data-id="element-1426">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1427">
              Pacer Benefits
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1428">
              Join our elite pacer team and enjoy exclusive perks while making a
              difference in the running community
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1429">
            {/* Benefit 1 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1430">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1431">
                <Award className="h-7 w-7 text-white" data-id="element-1432" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1433">
                Free Race Entries
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1434">
                Receive complimentary race registrations for events where you
                serve as a pacer
              </p>
            </div>

            {/* Benefit 2 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1435">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1436">
                <Star className="h-7 w-7 text-white" data-id="element-1437" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1438">
                Exclusive Gear
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1439">
                Get official RaceLookup pacer apparel including singlets, hats,
                and race day essentials
              </p>
            </div>

            {/* Benefit 3 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1440">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1441">
                <Users className="h-7 w-7 text-white" data-id="element-1442" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1443">
                Pacer Community
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1444">
                Connect with experienced pacers nationwide through our private
                network and events
              </p>
            </div>

            {/* Benefit 4 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1445">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1446">
                <TrendingUp className="h-7 w-7 text-white" data-id="element-1447" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1448">
                Training Resources
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1449">
                Access exclusive pacing strategies, training plans, and expert
                coaching materials
              </p>
            </div>

            {/* Benefit 5 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1450">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1451">
                <Calendar className="h-7 w-7 text-white" data-id="element-1452" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1453">
                Flexible Schedule
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1454">
                Choose which races to pace based on your availability and
                preferred distances
              </p>
            </div>

            {/* Benefit 6 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1455">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1456">
                <Zap className="h-7 w-7 text-white" data-id="element-1457" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1458">
                Recognition
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1459">
                Get featured on RaceLookup platforms and receive certificates
                for your pacing achievements
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Requirements Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-1460">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1461">
          <div className="text-center mb-12" data-id="element-1462">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1463">
              Pacer Requirements
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1464">
              To ensure the best experience for runners, we look for pacers who
              meet these criteria
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 sm:p-10 border-2 border-gray-100" data-id="element-1465">
            <ul className="space-y-4" data-id="element-1466">
              <li className="flex items-start gap-4" data-id="element-1467">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1468">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-1469" />
                </div>
                <div data-id="element-1470">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1471">
                    Proven Race Experience
                  </div>
                  <div className="text-gray-600" data-id="element-1472">
                    Completed at least 5 races at the distance you wish to pace,
                    with consistent finish times
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1473">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1474">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-1475" />
                </div>
                <div data-id="element-1476">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1477">
                    Pace Consistency
                  </div>
                  <div className="text-gray-600" data-id="element-1478">
                    Demonstrate ability to maintain even splits within 5-10
                    seconds per mile throughout a race
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1479">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1480">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-1481" />
                </div>
                <div data-id="element-1482">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1483">
                    Strong Communication
                  </div>
                  <div className="text-gray-600" data-id="element-1484">
                    Excellent interpersonal skills to motivate and guide runners
                    of all levels
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1485">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1486">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-1487" />
                </div>
                <div data-id="element-1488">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1489">
                    Reliability
                  </div>
                  <div className="text-gray-600" data-id="element-1490">
                    Commitment to showing up on race day and fulfilling pacing
                    responsibilities
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1491">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1492">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-1493" />
                </div>
                <div data-id="element-1494">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1495">
                    Positive Attitude
                  </div>
                  <div className="text-gray-600" data-id="element-1496">
                    Enthusiastic, encouraging demeanor that inspires confidence
                    in runners
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1497">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1498">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-1499" />
                </div>
                <div data-id="element-1500">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1501">
                    Course Knowledge
                  </div>
                  <div className="text-gray-600" data-id="element-1502">
                    Willingness to study race courses and understand terrain,
                    aid stations, and key mile markers
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-1503">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1504">
          <div className="text-center mb-12" data-id="element-1505">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1506">
              How It Works
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1507">
              From application to race day, here's your journey as a RaceLookup
              Pacer
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8" data-id="element-1508">
            {/* Step 1 */}
            <div className="relative" data-id="element-1509">
              <div className="bg-white rounded-2xl p-6 border-2 border-gray-100 text-center" data-id="element-1510">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-black text-xl" data-id="element-1511">
                  1
                </div>
                <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1512">Apply</h3>
                <p className="text-sm text-gray-600" data-id="element-1513">
                  Submit your application with race history and pacing
                  experience
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative" data-id="element-1514">
              <div className="bg-white rounded-2xl p-6 border-2 border-gray-100 text-center" data-id="element-1515">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-black text-xl" data-id="element-1516">
                  2
                </div>
                <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1517">
                  Get Certified
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1518">
                  Complete our online pacer training and certification program
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative" data-id="element-1519">
              <div className="bg-white rounded-2xl p-6 border-2 border-gray-100 text-center" data-id="element-1520">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-black text-xl" data-id="element-1521">
                  3
                </div>
                <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1522">
                  Choose Races
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1523">
                  Browse available pacing opportunities and sign up for races
                </p>
              </div>
            </div>

            {/* Step 4 */}
            <div className="relative" data-id="element-1524">
              <div className="bg-white rounded-2xl p-6 border-2 border-gray-100 text-center" data-id="element-1525">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-black text-xl" data-id="element-1526">
                  4
                </div>
                <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1527">
                  Lead & Inspire
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1528">
                  Guide runners to their goals and make a lasting impact
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Application Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] relative overflow-hidden" data-id="element-1529">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-1530">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-1531"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-1532"></div>
        </div>

        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10" data-id="element-1533">
          <div className="text-center mb-8" data-id="element-1534">
            <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-1535">
              Ready to Become a Pacer?
            </h2>
            <p className="text-lg text-white/90" data-id="element-1536">
              Apply now to join our elite pacer team and start making a
              difference in runners' lives
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 sm:p-8 border border-white/20" data-id="element-1537">
            <form className="space-y-4" data-id="element-1538">
              <div className="grid sm:grid-cols-2 gap-4" data-id="element-1539">
                <input type="text" placeholder="First Name" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-1540" />
                <input type="text" placeholder="Last Name" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-1541" />
              </div>
              <input type="email" placeholder="Email Address" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-1542" />
              <div className="grid sm:grid-cols-2 gap-4" data-id="element-1543">
                <select className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 transition-all" data-id="element-1544">
                  <option data-id="element-1545">Distance to Pace</option>
                  <option data-id="element-1546">5K</option>
                  <option data-id="element-1547">10K</option>
                  <option data-id="element-1548">Half Marathon</option>
                  <option data-id="element-1549">Marathon</option>
                </select>
                <input type="text" placeholder="Target Pace Time (e.g., 3:30:00)" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-1550" />
              </div>
              <textarea placeholder="Tell us about your race experience and why you'd be a great pacer (200 words max)" rows={4} className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all resize-none" data-id="element-1551"></textarea>
              <button type="submit" className="group w-full px-6 py-4 bg-white text-[#0E578E] font-bold rounded-xl hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-base" data-id="element-1552">
                <span data-id="element-1553">Submit Pacer Application</span>
                <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1554" />
              </button>
            </form>

            <p className="text-white/70 text-sm text-center mt-4" data-id="element-1555">
              Applications are reviewed within 5 business days. We'll contact
              you with next steps.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-1556">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1557">
          <div className="text-center mb-12" data-id="element-1558">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1559">
              What Pacers Say
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1560">
              Hear from experienced RaceLookup Pacers about their journey
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1561">
            {/* Testimonial 1 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-1562">
              <div className="flex items-center gap-1 mb-4" data-id="element-1563">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-1564" />)}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1565">
                "Being a RaceLookup Pacer has been incredibly rewarding. Helping
                runners achieve their goals and seeing their joy at the finish
                line makes every race special."
              </p>
              <div className="flex items-center gap-3" data-id="element-1566">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-full flex items-center justify-center text-white font-bold" data-id="element-1567">
                  SM
                </div>
                <div data-id="element-1568">
                  <div className="font-bold text-gray-900" data-id="element-1569">Sarah Martinez</div>
                  <div className="text-sm text-gray-600" data-id="element-1570">
                    Marathon Pacer • 3:30
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-1571">
              <div className="flex items-center gap-1 mb-4" data-id="element-1572">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-1573" />)}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1574">
                "The pacer community is amazing. I've made lifelong friends and
                learned so much about pacing strategy. Plus, the free race
                entries are a huge bonus!"
              </p>
              <div className="flex items-center gap-3" data-id="element-1575">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-full flex items-center justify-center text-white font-bold" data-id="element-1576">
                  JC
                </div>
                <div data-id="element-1577">
                  <div className="font-bold text-gray-900" data-id="element-1578">James Chen</div>
                  <div className="text-sm text-gray-600" data-id="element-1579">
                    Half Marathon Pacer • 1:45
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-1580">
              <div className="flex items-center gap-1 mb-4" data-id="element-1581">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-1582" />)}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1583">
                "I love the flexibility of choosing which races to pace. The
                training resources helped me become a better pacer and runner
                overall."
              </p>
              <div className="flex items-center gap-3" data-id="element-1584">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-full flex items-center justify-center text-white font-bold" data-id="element-1585">
                  EJ
                </div>
                <div data-id="element-1586">
                  <div className="font-bold text-gray-900" data-id="element-1587">Emily Johnson</div>
                  <div className="text-sm text-gray-600" data-id="element-1588">10K Pacer • 50:00</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}